export const defaultStyle = {
  name: 'New Style',
  custom_tags: [],
  product_group: null,
  fashionability: null,
  fit: null,
  price: null,
  pattern: null,
  gender: null
}
